import React from "react";
import { useTranslation } from "react-i18next";
import { useBookDemo } from "../../../../hooks/useBookDemo";

const CTABanner: React.FC = () => {
  const { t } = useTranslation();
  const openBookDemo = useBookDemo("landing_cta_banner");

  return (
    <div className="px-5">
      <div className="w-full mb-[60px] md:mb-[120px] mt-[30px] md:mt-[60px] max-w-[1200px] mx-auto bg-primary rounded-[32px] relative">
        <div
          className="max-w-[1200px] mx-auto rounded-[22px] md:rounded-[32px] px-[18px] w-full bg-primary py-[21.4px] md:py-12 relative z-20"
          style={{
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%)",
          }}
        >
          <div className="max-w-[1097px] mx-auto flex items-start md:items-center md:flex-row flex-col gap-6 md:gap-2 justify-between">
            <div className="flex items-start md:items-center md:flex-row flex-col gap-3 lg:gap-8">
              <img
                src="/assets/star.svg"
                alt="star"
                width={100}
                height={100}
                className="md:w-[100px] w-[64px]"
              />
              <div className="space-y-3">
                <h2 className="text-[32px] lg:text-[48px] leading-10 lg:leading-[58px] font-bold text-white">
                  {t("landing.cta.title")}
                </h2>
              </div>
            </div>
            <button 
              onClick={openBookDemo}
              className="text-nowrap md:w-fit w-full h-14 rounded-2xl bg-white text-primary text-[18px] leading-6 font-semibold px-[21.5px] transition-all duration-200 hover:bg-gray-50 hover:-translate-y-0.5 hover:shadow-[0_10px_25px_rgba(15,23,42,0.2)] active:translate-y-0 active:shadow-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-primary"
            >
              {t("landing.cta.button")}
            </button>
          </div>
        </div>
        <img
          src="/assets/star-2.svg"
          alt="Star 2"
          width={350}
          height={350}
          className="md:block hidden opacity-5 absolute bottom-0 lg:top-0 left-0"
        />
        <img
          src="/assets/star-5.svg"
          alt="Star 5"
          width={184}
          height={184}
          className="md:hidden block opacity-5 absolute bottom-0 lg:top-0 left-0"
        />
        <img
          src="/assets/star-3.svg"
          alt="Star 3"
          width={160}
          height={160}
          className="md:block hidden opacity-5 absolute top-0 right-0"
        />
        <img
          src="/assets/star-4.svg"
          alt="Star 4"
          width={87}
          height={87}
          className="md:hidden block opacity-10 absolute top-0 right-0"
        />
      </div>
    </div>
  );
};

export default CTABanner;
